"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.shuffleMotives = exports.buildInstanceSteps = exports.buildInstanceSettings = exports.parseFormData = exports.getDynamicFlow = exports.matchTrigger = exports.triggerFromFormData = exports.selectTrigger = void 0;
const ui_1 = require("./ui");
const Poll_1 = __importDefault(require("../models/Poll"));
const constants_1 = require("../constants");
const { get, merge, omit, isEmpty, pickBy, pick } = require('lodash');
const { getOneOf } = require('./hidash');
const selectTrigger = (triggers) => {
    const forcedTrigger = triggers.find((trigger) => !get(trigger, 'metadata.settings.random_poll', true));
    if (forcedTrigger)
        return forcedTrigger;
    return triggers[Math.floor(Math.random() * triggers.length)];
};
exports.selectTrigger = selectTrigger;
const triggerFromFormData = ({ formData, triggerData, answeredPolls = [], }) => {
    if (!formData)
        return undefined;
    const types = triggerData.type
        ? Array.isArray(triggerData.type)
            ? triggerData.type
            : [triggerData.type]
        : [];
    const { triggers } = formData;
    if (triggerData.force && triggerData.pollId) {
        return {
            type: 'modal',
            poll_id: triggerData.pollId,
        };
    }
    const filtered = [];
    if (!triggers) {
        return {
            poll_id: formData.polls[0].id,
        };
    }
    (triggers || [])
        // @ts-ignore
        .filter((trigger) => !answeredPolls.includes(trigger.poll_id))
        .forEach((trigger) => {
        // externalId required
        const externalIdRequired = get(trigger, 'metadata.externalIdRequired');
        if (externalIdRequired && triggerData.externalId === undefined)
            return;
        // Type
        if (types.length > 0 && !types.includes(trigger.type))
            return;
        // Other conditions
        const conditions = get(trigger, 'metadata.conditions', []);
        const match = conditions.every((condition) => {
            const value = get(triggerData, condition.path, condition.default);
            const operator = condition.operator || '==';
            if (operator === '==')
                return value === condition.value;
            if (operator === '!=')
                return value !== condition.value;
            if (operator === '>')
                return Number(value) > Number(condition.value);
            if (operator === '>=')
                return Number(value) >= Number(condition.value);
            if (operator === '<')
                return Number(value) < Number(condition.value);
            if (operator === '<=')
                return Number(value) <= Number(condition.value);
            return false;
        });
        const urlOkay = (() => {
            const { url = '' } = triggerData;
            if (trigger.url_regex !== undefined) {
                if (isEmpty(trigger.url_regex))
                    return true;
                if (trigger.url_regex === `${url}$`)
                    return true;
                if (url.indexOf(trigger.url_regex) >= 0)
                    return true;
                return false;
            }
            return true;
        })();
        if (urlOkay && match) {
            filtered.push(trigger);
        }
    });
    return (0, exports.selectTrigger)(filtered);
};
exports.triggerFromFormData = triggerFromFormData;
const matchTrigger = ({ polls, trigger }) => {
    const findPollById = (id) => polls.find((find) => find.id === id);
    const poll = findPollById(trigger.poll_id);
    return { poll };
};
exports.matchTrigger = matchTrigger;
const getDynamicFlow = ({ modules, answers }) => {
    const dynamicModules = [];
    let currentModule = modules[0];
    let blocked = false;
    do {
        if (!currentModule) {
            break;
        }
        const find = dynamicModules.find((find) => find === currentModule);
        if (find) {
            console.error('Smile: Cycle rendundacy detected.');
            currentModule = undefined;
            break;
        }
        if (get(currentModule, 'type', 'question') !== 'thanks') {
            dynamicModules.push(currentModule);
            const { 
            // @ts-ignore
            nextItem: nextQuestion, 
            // @ts-ignore
            blocked: newBlocked, } = currentModule.getNext(answers);
            blocked = newBlocked !== null && newBlocked !== void 0 ? newBlocked : false;
            currentModule = nextQuestion;
            continue;
        }
        else {
            currentModule = undefined;
            break;
        }
    } while (currentModule);
    return ({
        blocked,
        modules: dynamicModules,
    });
};
exports.getDynamicFlow = getDynamicFlow;
const parseFormData = (rawFormData) => {
    if (typeof rawFormData === 'string') {
        return {
            polls: [],
            triggers: [],
            values: {
                expired: rawFormData === 'campaign-expired',
            }
        };
    }
    const polls = rawFormData.polls || [rawFormData.poll];
    const { campaign } = rawFormData;
    return Object.assign(Object.assign({ triggers: [] }, omit(rawFormData, ['poll', 'polls'])), { polls: polls.map((poll) => new Poll_1.default(Object.assign({ campaign }, poll))), values: {
            expired: !get(rawFormData, 'poll') && !get(rawFormData, 'polls'),
            appMode: get(rawFormData, 'poll.route.mode')
        } });
};
exports.parseFormData = parseFormData;
const themeColor = /^--.+$/;
const defaultLightPalette = {
    '--close-button-color': '#000000',
    '--question-color': '#4200db',
    '--arrow-icon-color': '#ffffff',
    '--background-color': '#ffffff',
    '--font-family-text': 'Nunito',
    '--progressBar-color': '#4200db',
    '--marginTopThanksTitle': '30px',
    '--font-family-questions': 'Nunito Sans',
    '--arrow-background-color': '#4200db',
    '--button-send-font-color': '#ffffff',
    '--response-selected-color': '#4200db',
    '--button-send-background-color': '#4200db',
};
const defaultDarkPalette = {
    '--close-button-color': '#ffffff',
    '--question-color': '#4200db',
    '--arrow-icon-color': '#000000',
    '--background-color': '#000000',
    '--font-family-text': 'Nunito',
    '--progressBar-color': '#4200db',
    '--marginTopThanksTitle': '30px',
    '--font-family-questions': 'Nunito Sans',
    '--arrow-background-color': '#4200db',
    '--button-send-font-color': '#000000',
    '--response-selected-color': '#4200db',
    '--button-send-background-color': '#4200db',
};
const buildInstanceSettings = ({ formData, poll, settingsOverride = {}, defaultSettings }) => {
    var _a, _b;
    const { campaign = {}, device = {} } = formData !== null && formData !== void 0 ? formData : {};
    const legacyPalette = pickBy((_a = formData === null || formData === void 0 ? void 0 : formData.theme) !== null && _a !== void 0 ? _a : {}, (value, key) => key.match(themeColor) && !['--buttonType'].includes(key));
    const legacyIsDark = (0, ui_1.isDark)((_b = legacyPalette['--background-color']) !== null && _b !== void 0 ? _b : constants_1.defaultInstanceSettings.ui.theme.lightPalette['--background-color']);
    const lightPalette = merge({}, defaultLightPalette, legacyIsDark ? {} : legacyPalette);
    const darkPalette = merge({}, defaultDarkPalette, legacyIsDark ? legacyPalette : {});
    // Theme
    const rawTheme = merge({
        templates: [],
        lightPalette,
        darkPalette,
    }, get(formData, 'theme'), get(campaign, 'metadata.theme'), get(device, 'metadata.theme'), get(poll, 'metadata.theme'));
    const header = get(rawTheme, 'header') ||
        getOneOf([campaign, device, poll], 'metadata.settings.header');
    const footer = get(rawTheme, 'footer') ||
        getOneOf([campaign, device, poll], 'metadata.settings.footer');
    const form = merge({}, get(campaign, 'metadata.form'), get(device, 'metadata.form'), get(poll, 'metadata.form'));
    // Thanks
    const thanks = getOneOf([campaign, device, poll], 'metadata.thanks');
    const socialNetworks = getOneOf([poll, device, campaign], ['metadata.redes', 'metadata.thanks.redes'], []);
    const links = getOneOf([campaign, device, poll], 'metadata.links', []);
    const theme = pick(rawTheme, Object.keys(constants_1.defaultInstanceSettings.ui.theme));
    merge(theme, {
        defaultPalette: theme.defaultPalette || (legacyIsDark ? 'dark' : 'light'),
    });
    if (rawTheme['--buttonType'] !== undefined)
        theme.buttonType = rawTheme['--buttonType'];
    const defaults = merge({}, constants_1.defaultInstanceSettings, defaultSettings);
    return merge(defaults, {
        device,
        contact: get(formData, 'contact'),
        store: get(formData, 'store'),
        thanks,
        socialNetworks,
        links,
        form,
        nav: {
            autoStep: getOneOf([poll], 'metadata.settings.autoStep', defaults.nav.autoStep),
            pageSize: getOneOf([poll], 'metadata.settings.pageSize', defaults.nav.pageSize),
            splitModuleComponents: getOneOf([campaign, poll], 'metadata.settings.splitModuleComponents', defaults.nav.splitModuleComponents),
        },
        ui: {
            header,
            footer,
            theme,
        },
    }, settingsOverride);
};
exports.buildInstanceSettings = buildInstanceSettings;
const buildInstanceSteps = ({ instance }) => {
    const { response, settings: { nav: { pageSize = 1, splitModuleComponents = false } } } = instance;
    const pages = [];
    const pushRow = (row, forceSplit = false) => {
        if (pages.length === 0) {
            pages.push({
                type: 'page',
                rows: [],
            });
        }
        if (forceSplit || pages[pages.length - 1].rows.length >= pageSize) {
            pages.push({
                type: 'page',
                rows: [],
            });
        }
        if (pages[pages.length - 1].rows.length === 0) {
            pages[pages.length - 1].moduleIndex = row.module.index;
        }
        pages[pages.length - 1].rows.push(row);
    };
    response.modules.forEach((moduleInstance) => {
        const components = moduleInstance.module.components;
        if (splitModuleComponents) {
            components.forEach((component) => {
                pushRow({
                    type: 'module',
                    module: moduleInstance.module,
                    moduleInstance,
                    components: [component],
                });
            });
        }
        else {
            pushRow({
                type: 'module',
                module: moduleInstance.module,
                moduleInstance,
                components,
            });
        }
    });
    return pages;
};
exports.buildInstanceSteps = buildInstanceSteps;
const shuffleMotives = (motives) => {
    var notMove = motives.filter((e) => get(e, 'metadata.settings.notMove')); //los motivos que no se deben mover
    var lastMotives = motives.filter((e) => get(e, 'metadata.settings.lastMotive')); //los motivos que deben quedar al final
    motives = motives.filter((e) => !lastMotives.includes(e));
    var j, x, i;
    for (i = motives.length - 1; i > 0; i--) {
        if (!notMove.includes(motives[i])) {
            j = Math.floor(Math.random() * (i + 1));
            x = motives[i];
            motives[i] = motives[j];
            motives[j] = x;
        }
    }
    // agrego los ultimos motivos al array
    lastMotives.forEach((element) => {
        motives.push(element);
    });
    return motives;
};
exports.shuffleMotives = shuffleMotives;
